// extracted by mini-css-extract-plugin
module.exports = {"button_active":"PaginationButton_button_active__2F6w9","button":"PaginationButton_button__NHdiB"};